
import Vue from "vue"
import type { Session } from "@/types/api/program"

export default Vue.extend({
  props: {
    group: { type: String, default: "festival" },
  },

  data () {
    const periods = {
      morning: { name: "Утро", start: 9, finish: 12 },
      day: { name: "День", start: 12, finish: 17 },
      evening: { name: "Вечер", start: 17, finish: 21 },
    }

    return {
      sessions: [] as Session[],
      periods,
      period: Object.keys(periods)[0] as keyof typeof periods,
    }
  },

  async fetch () {
    await this.fetchSessions()
  },

  computed: {
    filteredSessions (): Session[] {
      return this.sessions
      // const period = this.periods[this.period]

      // return this.sessions.filter(({ start }) => {
      //   const hours = (new Date(start)).getUTCHours()
      //   const mskOffset = 3
      //   return hours >= period.start - mskOffset &&
      //     hours < period.finish - mskOffset
      // })
    },
  },

  methods: {
    async fetchSessions () {
      const [res, err] = await this.$api.program.getSessions({
        params: {
          "paginator[limit]": 9999,
          "filter[group]": this.group,
        },
      })
      if (err) console.error(err)
      else this.sessions = (this.$api.helpers.getList(res) as Session[])
        .sort((a, b) => a.start - b.start)
    },

    getCover (s: Session): string {
      return s.image?.url || "/img/landing/hero-1.jpg"
    },
  },
})
